import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

// @dynamic
export class UserRules {
  /**
   * @Sample æ¡ä¾ï¼
   * ```
   * UserRules.sample('hello', 'è¯·è¾å¥')
   * ```
   */
  static sample(str: string, errorMsg = `è¯·è¾å¥'${str}'å­æ®µ`): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return control.value && control.value !== str
        ? { sample: errorMsg }
        : null;
    };
  }
}

// æ´æ°ctrlä¸çæ ¡éªæ¡ä»¶
export function updateRule(ctrl, rules) {
  ctrl.setValidators(rules);
  ctrl.updateValueAndValidity();
}

// è¥æ¯æRequiredå±æ§éè¦æ¾ç¤ºå°å¤çä¸
export function updateRequired(conf, prop, required) {
  const item = conf.filter(i => i.prop === prop)[0];
  item.required = required;
}
